import React from 'react';
import { useTranslation } from 'react-i18next';
import { PDFDownloadLink } from '@react-pdf/renderer';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import VerifiedIcon from '@mui/icons-material/Verified';
import Certificate from './PdfDocument';
import { useGhgOrganization } from 'src/common/hooks';
import CircularText, { useSvgAsBase64 } from 'src/components/CircularText';

export type DownloadCertificateItemProps = {
  disabled?: boolean;
  button?: React.ReactNode;
};

function DownloadButton() {
  const { t } = useTranslation();

  return (
    <ListItemButton>
      <ListItemIcon>
        <VerifiedIcon />
      </ListItemIcon>
      <ListItemText primary={t('menu.download-certificate')} />
    </ListItemButton>
  );
}

export default function DownloadCertificateItem(
  props: DownloadCertificateItemProps
) {
  const { disabled = false } = props;
  const { t } = useTranslation();
  const organization = useGhgOrganization();

  const svgRefTop = React.useRef<SVGSVGElement>(null);
  const svgRefBottom = React.useRef<SVGSVGElement>(null);

  const topLogoBase64 = useSvgAsBase64(svgRefTop);
  const bottomLogoBase64 = useSvgAsBase64(svgRefBottom);

  return (
    <ListItem>
      {disabled
        ? props.button || <DownloadButton />
        : topLogoBase64 &&
          bottomLogoBase64 && (
            <PDFDownloadLink
              style={{
                textDecoration: 'none',
                color: 'inherit',
                width: '100%',
              }}
              document={
                <Certificate
                  organization={organization}
                  topLogoBase64={topLogoBase64}
                  bottomLogoBase64={bottomLogoBase64}
                />
              }
            >
              {props.button || <DownloadButton />}
            </PDFDownloadLink>
          )}
      <Box display="none">
        <CircularText
          svgRef={svgRefTop}
          text={t('ghg.certificate.measuringCarbonFootprint')}
        />
        <CircularText
          svgRef={svgRefBottom}
          text={t('ghg.certificate.withEnvirly')}
          direction="down"
        />
      </Box>
    </ListItem>
  );
}
